import { requestClientTool } from "@src/store/slices/experienceBuilder/common/thunks/requestClientTool";

import { matchClientTool } from "../detect";
import { Continuation, Matcher } from "../types";

type EvaluateJsOutput = {
  js_result: unknown;
};

/** Shape the client's evaluate-js output into the LLM tool-result content — a
 * single text block carrying the `js_result` JSON. Screenshots are produced
 * server-side, so there's no media block here. */
function toContinuation(
  toolCallId: string,
  out: EvaluateJsOutput
): Continuation {
  return {
    kind: "tool-result",
    toolCallId,
    output: {
      type: "content",
      value: [
        { type: "text", text: JSON.stringify({ js_result: out.js_result }) },
      ],
    },
  };
}

/**
 * `visual_builder_evaluate_js` — the one client-produced-result tool. The server
 * parks the open call; this runs the JS evaluation against the live iframe via
 * the generic client-tool channel and answers the call with a `tool-result`.
 * Read-only (no page effect), so the resolve thunk just runs and returns.
 */
export const evaluateJs: Matcher = {
  match: (part) => {
    const call = matchClientTool(part, "visual_builder_evaluate_js");
    if (!call) return null;
    return async () => {
      try {
        const out = (await requestClientTool(
          "visual_builder_evaluate_js",
          call.input
        )) as EvaluateJsOutput;
        return toContinuation(call.toolCallId, out);
      } catch (e) {
        // Answer the open call with an error so the model isn't left waiting.
        return {
          kind: "tool-result",
          toolCallId: call.toolCallId,
          output: {
            type: "content",
            value: [
              {
                type: "text",
                text: `Evaluation failed: ${
                  e instanceof Error ? e.message : String(e)
                }`,
              },
            ],
          },
        };
      }
    };
  },
};
